export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/number.js
// module id = 79
// module chunks = 3 4